import { z } from 'zod';
import { featureFlagNameSchema } from '../../enums.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            name: featureFlagNameSchema,
            enabled: z.boolean(),
            description: z.string(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var GetAll;
(function (GetAll) {
    GetAll.responseSchema = z.array(Get.Response.schema);
})(GetAll || (GetAll = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.schema = z.object({
            enabled: z.boolean(),
        });
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));

export { Get, GetAll, Update };
